/**
 * Shared financial tolerances for the household custom-allocation editor.
 * `ALLOCATION_WEIGHT_TOLERANCE` and `MODEL_SNAP_TOLERANCE` match holding-service
 * `setCustomExpectedPercentages.ts`.
 *
 * Kept as separately named constants even when numeric values coincide —
 * weight-sum checks and override-diff checks must be tunable independently.
 */

/** Column weight sum vs securityMassFraction / row weight balance. */
export const ALLOCATION_WEIGHT_TOLERANCE = 0.0001;

/**
 * Draft vs persisted/displayed fraction —
 * "changed vs unchanged" detection for save diffs and dirty state.
 * Not for "is a persisted override stored" — see MODEL_SNAP_TOLERANCE.
 */
export const CUSTOM_OVERRIDE_TOLERANCE = 0.0001;

// The backend only unsets an override that equals the model within float/rounding
// noise; a value 1bp off the model is stored as sent, so "has overrides" must not
// use the looser CUSTOM_OVERRIDE_TOLERANCE or Reset skips the stored ones.
export const MODEL_SNAP_TOLERANCE = 1e-9;

/** Per-member cents budget for AGGREGATE_CONSERVATION-style row drift. */
export const CENTS_TOLERANCE_PER_MEMBER = 10;

export const dollarToleranceCents = (memberCount: number) =>
  CENTS_TOLERANCE_PER_MEMBER * memberCount;
